// Contextual actions bar: appears when there's a selection.
// Layer ops, align, distribute, duplicate, delete.
import { useCanvas } from '../state/canvas-store.js';

export const ActionsBar = () => {
  const selectedCount = useCanvas((s) => s.selectedIds.size);
  const bringToFront = useCanvas((s) => s.bringToFront);
  const sendToBack = useCanvas((s) => s.sendToBack);
  const bringForward = useCanvas((s) => s.bringForward);
  const sendBackward = useCanvas((s) => s.sendBackward);
  const align = useCanvas((s) => s.align);
  const distribute = useCanvas((s) => s.distribute);
  const duplicateSelected = useCanvas((s) => s.duplicateSelected);
  const deleteSelected = useCanvas((s) => s.deleteSelected);
  const commit = useCanvas((s) => s.commit);

  if (selectedCount === 0) return null;

  const btn =
    'grid place-items-center w-8 h-8 rounded-md bg-white dark:bg-neutral-800 text-neutral-700 dark:text-neutral-200 hover:bg-neutral-100 dark:hover:bg-neutral-700 border border-neutral-200 dark:border-neutral-700 text-xs font-medium';

  return (
    <aside className="absolute right-4 top-16 z-10 rounded-xl bg-white/95 dark:bg-neutral-900/95 backdrop-blur shadow-lg ring-1 ring-black/5 p-2 flex flex-col gap-2 w-44">
      <div className="text-[11px] uppercase tracking-wide text-neutral-500 dark:text-neutral-400 pb-1">
        {selectedCount} selected
      </div>

      <div className="flex flex-col gap-1.5">
        <div className="text-[10px] uppercase text-neutral-400">Layer</div>
        <div className="grid grid-cols-4 gap-1">
          <button className={btn} onClick={() => { sendToBack(); commit(); }} title="Send to back">⤓⤓</button>
          <button className={btn} onClick={() => { sendBackward(); commit(); }} title="Send backward">⤓</button>
          <button className={btn} onClick={() => { bringForward(); commit(); }} title="Bring forward">⤒</button>
          <button className={btn} onClick={() => { bringToFront(); commit(); }} title="Bring to front">⤒⤒</button>
        </div>
      </div>

      {selectedCount >= 2 ? (
        <div className="flex flex-col gap-1.5">
          <div className="text-[10px] uppercase text-neutral-400">Align</div>
          <div className="grid grid-cols-3 gap-1">
            <button className={btn} onClick={() => { align('left'); commit(); }} title="Align left">L</button>
            <button className={btn} onClick={() => { align('centerX'); commit(); }} title="Align center X">CX</button>
            <button className={btn} onClick={() => { align('right'); commit(); }} title="Align right">R</button>
            <button className={btn} onClick={() => { align('top'); commit(); }} title="Align top">T</button>
            <button className={btn} onClick={() => { align('centerY'); commit(); }} title="Align center Y">CY</button>
            <button className={btn} onClick={() => { align('bottom'); commit(); }} title="Align bottom">B</button>
          </div>
        </div>
      ) : null}

      {selectedCount >= 3 ? (
        <div className="flex flex-col gap-1.5">
          <div className="text-[10px] uppercase text-neutral-400">Distribute</div>
          <div className="grid grid-cols-2 gap-1">
            <button className={btn} onClick={() => { distribute('horizontal'); commit(); }}>H</button>
            <button className={btn} onClick={() => { distribute('vertical'); commit(); }}>V</button>
          </div>
        </div>
      ) : null}

      <div className="flex gap-1">
        <button className={btn + ' flex-1'} onClick={duplicateSelected} title="Duplicate">Dup</button>
        <button
          className={btn + ' flex-1 !text-rose-500'}
          onClick={() => { deleteSelected(); commit(); }}
          title="Delete"
        >
          ✕
        </button>
      </div>
    </aside>
  );
};
